import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../FaIcon';
import {usePortalClient} from '../../context/PortalClientContext';

const SEARCH_THRESHOLD = 6;

/**
 * Pantalla de bienvenida del portal multi-cliente: se muestra SOLO cuando el usuario tiene
 * varios clientes y todavía no eligió con cuál entrar (primer login multi, o el último usado
 * fue revocado). Elegir persiste la selección (keyed por usuario) y entra directo las veces
 * siguientes. Patrón visual del selector de cliente del agente, con el tema del portal.
 */
export const PortalClientWelcome = () => {
    const {t} = useTranslation();
    const {clients, setActiveClient} = usePortalClient();
    const [search, setSearch] = useState('');

    if (!clients || clients.length === 0) return null;

    const normalizedSearch = search.trim().toLowerCase();
    const filtered = normalizedSearch
        ? clients.filter(client => (client.name || '').toLowerCase().includes(normalizedSearch))
        : clients;

    return (
        <div className="portal-client-welcome">
            <h1 className="portal-client-welcome__title">{t('portal.welcome.title')}</h1>
            <p className="portal-client-welcome__subtitle">
                {t('portal.welcome.subtitle', {count: clients.length})}
            </p>

            {clients.length > SEARCH_THRESHOLD && (
                <input
                    type="search"
                    className="portal-client-welcome__search"
                    placeholder={t('portal.switcher.search')}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    autoFocus
                />
            )}

            <div className="portal-client-welcome__list">
                {filtered.map(client => (
                    <button
                        key={client.id}
                        className="portal-client-welcome__item"
                        onClick={() => setActiveClient(client.id)}
                    >
                        <span className="portal-client-welcome__avatar" aria-hidden="true">
                            {(client.name || '?').charAt(0).toUpperCase()}
                        </span>
                        <span className="portal-client-welcome__name">{client.name}</span>
                        <FaIcon iconName="arrow-right" />
                    </button>
                ))}
                {filtered.length === 0 && (
                    <div className="portal-client-welcome__empty">{t('portal.switcher.no_results')}</div>
                )}
            </div>
        </div>
    );
};
